import { useState } from "react";

/**
 * Custom hook for managing image upload state
 * Handles file selection, preview generation, and deletion state
 */
export const useImageUpload = (initialImageName = null) => {
  const [imageState, setImageState] = useState({
    file: null,
    value: "",
    preview: null,
    isDeleted: false,
  });

  const handleFileSelect = (event, maxFileSize = 500 * 1024) => {
    const file = event.target.files[0];

    if (!file) return;

    // Validate file size
    if (file.size > maxFileSize) {
      return {
        success: false,
        error: `Dosya boyutu ${maxFileSize / 1024}KB'den büyük olamaz.`,
      };
    }

    // Create preview URL
    const preview = URL.createObjectURL(file);

    setImageState({
      file: file,
      value: event.target.value,
      preview: preview,
      isDeleted: false,
    });

    return { success: true };
  };

  const handleDelete = () => {
    // Revoke preview URL to prevent memory leaks
    if (imageState.preview) {
      URL.revokeObjectURL(imageState.preview);
    }

    setImageState({
      file: null,
      value: "",
      preview: null,
      isDeleted: true,
    });
  };

  const reset = () => {
    if (imageState.preview) {
      URL.revokeObjectURL(imageState.preview);
    }

    setImageState({
      file: null,
      value: "",
      preview: null,
      isDeleted: false,
    });
  };

  return {
    imageState,
    handleFileSelect,
    handleDelete,
    reset,
  };
};
